import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AuthGuard from '@/components/AuthGuard';
import Layout from '@/components/Layout';
import LoginPage from '@/pages/LoginPage';
import ApplicationsPage from '@/pages/ApplicationsPage';
import ApiReferencePage from '@/pages/ApiReferencePage';
import GuidesPage from '@/pages/GuidesPage';
import WebhooksPage from '@/pages/WebhooksPage';
import UsagePage from '@/pages/UsagePage';
import PlaygroundPage from '@/pages/PlaygroundPage';
import StatusPage from '@/pages/StatusPage';
import ComponentsPage from '@/pages/ComponentsPage';

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } } });

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/*"
            element={
              <AuthGuard>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Navigate to="/apps" replace />} />
                    <Route path="/apps" element={<ApplicationsPage />} />
                    <Route path="/reference" element={<ApiReferencePage />} />
                    <Route path="/guides" element={<GuidesPage />} />
                    <Route path="/webhooks" element={<WebhooksPage />} />
                    <Route path="/usage" element={<UsagePage />} />
                    <Route path="/playground" element={<PlaygroundPage />} />
                    <Route path="/status" element={<StatusPage />} />
                    <Route path="/components" element={<ComponentsPage />} />
                  </Routes>
                </Layout>
              </AuthGuard>
            }
          />
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
